import { FormActionButton } from '@workwave-tidal/core/form'
import { useEditingStateWithCtx } from '@/atoms'
import { emptyDriverId, form } from '../formState'
import { useTexts } from '../hooks/useTexts'

export function Footer() {
  const { resetEditing } = useEditingStateWithCtx('driver')
  const { field: idField } = form.useFormField('id')
  const { footer } = useTexts()

  const {
    meta: { submitting, validating, status },
  } = form.useFormMeta()

  const creating = idField.value === emptyDriverId

  // When creating a new entity the submit button should be enabled also when the form is in a pristine status
  const saveDisabled = creating
    ? validating || submitting
    : status === 'pristine' || validating || submitting

  return (
    <>
      <FormActionButton
        label={footer.cancel}
        onClick={resetEditing}
        testId="footer-secondary-button"
      />
      <FormActionButton
        label={creating ? footer.create : footer.save}
        variant="contained"
        type="submit"
        disabled={saveDisabled}
        loading={submitting || validating}
        testId="footer-primary-button"
      />
    </>
  )
}
